module.exports = __webpack_public_path__ + "img/DE00156.34ff09ee.png";